import { render } from "./CCRecipientsStep.vue?vue&type=template&id=1d1e517c&scoped=true"
import script from "./CCRecipientsStep.vue?vue&type=script&lang=js"
export * from "./CCRecipientsStep.vue?vue&type=script&lang=js"

import "./CCRecipientsStep.vue?vue&type=style&index=0&id=1d1e517c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1e517c"]])

export default __exports__